import { gsap } from 'gsap';
import { Container, Sprite } from '../../odie';
import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { ParticleEmitter } from '../particles/ParticleEmitter';
import { getMatch2AssetPath } from '../util/assets';
import { MovieClip } from '@play-co/timestep-core/ui';

export class LockBreakAnimation extends Container implements IAnimation {
  public async start() {
    // create blast
    const blast = this.createBlast();

    // create debris emitter
    const debrisEmitter = this.createEmitter();

    // animate debris and blast
    await Promise.all([
      this.animateDebris(debrisEmitter),
      this.animateBlast(blast),
    ]);
  }

  public stop() {}

  private async animateDebris(debris: ParticleEmitter) {
    // spawn debris
    this.addChild(debris.view);

    // start
    await debris.start();

    // despawn blast
    this.removeChild(debris.view);
  }

  private async animateBlast(blast: MovieClip) {
    // spawn blast
    this.view.addSubview(blast);

    // animate
    await blast.playAsync('lantern_stage3');

    // despawn blast
    this.view.removeSubview(blast);
  }

  private createEmitter(): ParticleEmitter {
    return app.particles.create({
      textures: [
        getMatch2AssetPath('blocks/lock/particle_lantern_01.png'),
        getMatch2AssetPath('blocks/lock/particle_lantern_02.png'),
        getMatch2AssetPath('blocks/lock/particle_lantern_03.png'),
        getMatch2AssetPath('blocks/lock/particle_lantern_rect.png'),
      ],
      rate: 0,
      limit: 7,
      emitterDuration: 0,
      duration: 2.5,
      velocity: { x: 0, y: -200 },
      scale: [
        { x: 0.7, y: 0.7 },
        { x: 1.1, y: 1.1 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [60, 180] },
        { type: 'gravity', gravity: { x: 0, y: 700 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic' },
      ],
    });
  }

  private createBlast(): MovieClip {
    const blast = new MovieClip({
      superview: this.view,
      url: getMatch2AssetPath('blocks/lock'),
      scale: 0.9,
      centerOnOrigin: true,
    });
    return blast;
  }
}
